import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Label as AriaLabel } from "react-aria-components";
import { useDefaultLabelStyle, useStyle } from "../context.js";
import { base, icon } from "./Label.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseLabel = (t0, ref) => {
  const $ = _c(15);
  let Icon;
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      icon: Icon,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = children;
    $[3] = props;
  } else {
    Icon = $[1];
    children = $[2];
    props = $[3];
  }
  const style = useStyle();
  const defaultLabelStyle = useDefaultLabelStyle();
  let t1;
  if ($[4] !== defaultLabelStyle || $[5] !== style) {
    t1 = base({
      style,
      defaultLabelStyle
    });
    $[4] = defaultLabelStyle;
    $[5] = style;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== Icon) {
    t2 = Icon && /*#__PURE__*/_jsx(Icon, {
      className: icon
    });
    $[7] = Icon;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== props || $[11] !== ref || $[12] !== t1 || $[13] !== t2) {
    t3 = /*#__PURE__*/_jsxs(AriaLabel, {
      ref: ref,
      ...props,
      className: t1,
      children: [children, t2]
    });
    $[9] = children;
    $[10] = props;
    $[11] = ref;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export const Label = /*#__PURE__*/React.forwardRef(BaseLabel);
//# sourceMappingURL=Label.js.map